import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const Content = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.Xs};
  justify-content: space-between;

  > div {
    display: flex;
    flex-direction: column;
    gap: ${Spacing['3Xs']};

    > span {
      height: 1.375rem;
    }

    > span:nth-of-type(2) {
      color: ${Colors.gray[100]};
      height: 1.25rem;
    }
  }

  > svg {
    color: ${Colors.blue[100]};
  }
`;
